import OrderRecoveryScreen from './components/OrderRecoveryScreen';
import OrderAttentionAlert from './components/OrderAttentionAlert';
import UploadStorageAlert from './components/UploadStorageAlert';
import Tracking from './pages/Tracking';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth';
import Header from './components/Header';
import Footer from './components/Footer';
import Terms from './pages/Terms';
import ProtectedRoute from './components/ProtectedRoute';
import ItemList from './pages/ItemList';
import ItemDetail from './pages/ItemDetail';
import Login from './pages/Login';
import Signup from './pages/Signup';
import OwnerDashboard from './pages/OwnerDashboard';
import ItemForm from './pages/ItemForm';
import MyBookings from './pages/MyBookings';
import BookingDetail from './pages/BookingDetail';
import Account from './pages/Account';
import AdminDashboard from './pages/AdminDashboard';
import DeliveryDashboard from './pages/DeliveryDashboard';
import Pricing from './pages/Pricing';
import ChangePassword from './pages/ChangePassword';
import PasswordGate from './components/PasswordGate';
import SubscriptionGate from './components/SubscriptionGate';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Header />
        <div className="container"><UploadStorageAlert /><OrderAttentionAlert /></div>
        <div className="container pb-5">
          <PasswordGate>
          <SubscriptionGate>
          <Routes>
            <Route path="/order-recovery/:caseId" element={<ProtectedRoute roles={['owner', 'admin']}><OrderRecoveryScreen /></ProtectedRoute>} />
            <Route path="/tracking" element={<ProtectedRoute><Tracking /></ProtectedRoute>} />
            <Route path="/" element={<ItemList />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/items/:id" element={<ItemDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/owner"
              element={
                <ProtectedRoute roles={['owner']}>
                  <OwnerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/owner/items/new"
              element={
                <ProtectedRoute roles={['owner']}>
                  <ItemForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/owner/items/:id/edit"
              element={
                <ProtectedRoute roles={['owner']}>
                  <ItemForm />
                </ProtectedRoute>
              }
            />
            {/* The website owner (admin) edits any listing with the same ItemForm its owner uses,
                reached from the Details popup / Edit button on the admin Items tab. */}
            <Route
              path="/admin/items/:id/edit"
              element={
                <ProtectedRoute roles={['admin']}>
                  <ItemForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-bookings"
              element={
                <ProtectedRoute roles={['customer']}>
                  <MyBookings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-bookings/:id"
              element={
                <ProtectedRoute roles={['customer']}>
                  <BookingDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                // Owner Bookings & Cancellation v2 doc, "New roles" - the 3 finance_* roles land
                // on AdminDashboard's Finance tab (it self-gates the admin-only tabs internally),
                // so they need to clear this route guard too, not just admin.
                <ProtectedRoute roles={['admin', 'finance_employee', 'finance_lead', 'finance_manager']}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delivery"
              element={
                <ProtectedRoute roles={['delivery', 'admin']}>
                  <DeliveryDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account/password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<ItemList />} />
          </Routes>
          </SubscriptionGate>
          </PasswordGate>
        </div>
        <Footer />
      </AuthProvider>
    </BrowserRouter>
  );
}
